import { POI } from '../../../src/feature/navigator/navigator.model';

export const world: POI[] = [
  {
    id: 'from-north-to-beggen-1',
    mapId: '0-0',
    pos: [955, 196],
    destination: ['from-north-to-beggen-2'],
    spotlight: {
      title: 'Beggen - Road up north',
      description: 'The road ahead is long and turns out of sight. You are not sure you want to follow it.',
    },
  },
  {
    id: 'from-north-to-beggen-2',
    mapId: '0-0',
    pos: [953, 259],
    destination: ['from-north-to-beggen-1', 'from-north-to-beggen-3'],
    spotlight: {
      title: 'Beggen - Road to Beggen',
      description: 'The road is long. Beggen sits far ahead, small against the fields.',
    },
  },
  {
    id: 'from-north-to-beggen-3',
    mapId: '0-0',
    pos: [957, 325],
    destination: ['from-north-to-beggen-2', 'from-north-to-beggen-4'],
    spotlight: {
      title: 'Beggen - Road to Beggen',
      description: 'A cart has passed this way recently. Beggen is close enough that you can hear a dog barking.',
    },
  },
  {
    id: 'from-north-to-beggen-4',
    mapId: '0-0',
    pos: [961, 391],
    destination: ['from-north-to-beggen-3', 'beggen-1'],
    spotlight: {
      title: 'Beggen - Northern edge',
      description:
        'The fields end here. Wooden fences and the first houses of Beggen begin. A crossroad waits a little further on.',
    },
  },
  {
    id: 'beggen-1',
    mapId: '0-0',
    pos: [971, 473],
    destination: ['from-north-to-beggen-4', 'beggen-2'],
    spotlight: {
      title: 'Beggen - Northern crossroad',
      description: 'An old wooden cross leans at the meeting of the roads. A crow watches you from the top of it.',
    },
  },
  {
    id: 'beggen-2',
    mapId: '0-0',
    pos: [1039, 456],
    destination: ['beggen-1', 'beggen-3', 'beggen-4'],
    spotlight: {
      title: 'Beggen - The lane',
      description: 'Wooden houses lean against each other. A pig looks at you for a moment, then looks away.',
    },
  },
  {
    id: 'beggen-3',
    mapId: '0-0',
    pos: [1095, 446],
    destination: ['beggen-2', 'beggen-4', 'beggen-5'],
    spotlight: {
      title: 'Beggen - West of the village',
      description:
        'Wooden fences mark out a small yard beside the road. Through the pines, you can just see the corner of a house.',
    },
  },
  {
    id: 'beggen-4',
    mapId: '0-0',
    pos: [1074, 414],
    destination: ['beggen-3', 'beggen-5'],
    narratorId: 'merchant-beggen',
    spotlight: {
      title: 'Beggen - The merchant',
      description:
        'A wooden table stands outside a low house, half-covered in cloth, iron nails, and twists of dried herbs. The merchant watches over them from a stool.',
    },
  },
  {
    id: 'beggen-5',
    mapId: '0-0',
    pos: [1149, 418],
    destination: ['beggen-3', 'beggen-4', 'beggen-6', 'beggen-7', 'beggen-8'],
    spotlight: {
      title: 'Beggen - The village center',
      description: "You are standing in the middle of Beggen. It's a small town. Not much is going on.",
    },
  },
  {
    id: 'beggen-6',
    mapId: '0-0',
    pos: [1166, 380],
    destination: ['beggen-5', 'beggen-8'],
    narratorId: 'priest-beggen',
    spotlight: {
      title: 'Beggen - The chapel',
      description:
        'A small stone chapel stands close by the road. Its walls are patched against the weather, and no bell hangs over the low door.',
    },
  },
  {
    id: 'beggen-7',
    mapId: '0-0',
    pos: [1164, 471],
    destination: ['beggen-5', 'beggen-8'],
    spotlight: {
      title: 'Beggen - The barn',
      description: 'A barn of dark timber, its door barred. Sparrows have made themselves at home under the eaves.',
    },
  },
  {
    id: 'beggen-8',
    mapId: '0-0',
    pos: [1223, 414],
    destination: ['beggen-5', 'beggen-6', 'beggen-7', 'beggen-9'],
    spotlight: {
      title: 'Beggen - East of the village',
      description: 'The road runs east between low hedges. Not far away, you can hear the sound of running water.',
    },
  },
  {
    id: 'beggen-9',
    mapId: '0-0',
    pos: [1299, 409],
    destination: ['beggen-8', 'beggen-10'],
    spotlight: {
      title: 'Beggen - East road',
      description:
        'A wooden fence runs along one side of the road. An old man sits against it, eyes closed, his dog asleep at his feet.',
    },
  },
  {
    id: 'beggen-10',
    mapId: '0-0',
    pos: [1361, 403],
    destination: ['beggen-9', 'beggen-11'],
    spotlight: {
      title: 'Beggen - The bridge',
      description:
        'You are standing on the bridge leading into Beggen. The Alzette flows underneath. To the east, you can see a nice little fishing spot.',
    },
  },
  {
    id: 'beggen-11',
    mapId: '0-0',
    pos: [1417, 392],
    destination: ['beggen-10', 'beggen-12', 'beggen-13'],
    spotlight: {
      title: 'Beggen - East bank',
      description:
        'On this side of the bridge, a path drops down to the river. Another road continues east into the fields.',
    },
  },
  {
    id: 'beggen-12',
    mapId: '0-0',
    pos: [1419, 451],
    destination: ['beggen-11'],
    spotlight: {
      title: 'Beggen - The fishing spot',
      description:
        'A small, worn spot on the river bank, under the shade of an alder tree. A man stands in the shallow water, a fishing line in his hand. He looks up and gives you a friendly nod.',
    },
    narratorId: 'fisherman-beggen',
  },
  {
    id: 'beggen-13',
    mapId: '0-0',
    pos: [1484, 365],
    destination: ['beggen-11', 'beggen-14'],
    spotlight: {
      title: 'Beggen - East road',
      description:
        'The sound of the river is faint here. Wind moves through the long grass on either side of the road.',
    },
  },
  {
    id: 'beggen-14',
    mapId: '0-0',
    pos: [1564, 364],
    destination: ['beggen-13', 'beggen-15'],
    spotlight: {
      title: 'Beggen - East crossroad',
      description: 'A crossroad in the dirt. Roads lead off to the north and the south, into open country.',
    },
  },
  {
    id: 'beggen-15',
    mapId: '0-0',
    pos: [1617, 388],
    destination: ['beggen-14'],
    spotlight: {
      title: 'Beggen - The oak',
      description:
        'The oak tree is older than the road beside it. Insects move in its bark, and the earth around its roots is soft and dark.',
    },
    narratorId: 'oak-beggen',
  },
];
